import axios from "axios";

export const getNeedsRetake = (hook, closeHook=null) => {
    
   const token = localStorage.getItem("access_token");
   let url = process.env.REACT_APP_API_BASE_URL + '/api/get-needs-retake/';

    axios
    .get(url, {
        headers: { 
            Authorization: `Bearer ${token}` 
        }
    })
    .then((response) => {
        if (response.status === 200) {
            hook(response.data)
        }
        if (closeHook) {
            closeHook(true);
        }
    })
    .catch((error) => {
        console.error("Error fetching statistics:", error);
    });
}